import { useState } from "react";
import { styled } from "leva/plugin";

// Define the styled component for the context menu
const ContextMenuContainer = styled("div", {
	position: "absolute",
	top: "var(--top)",
	left: "var(--left)",
	backgroundColor: "$modalBackground",
	color: "$highlight2",
	border: "1px solid black",
	padding: "5px",
	zIndex: 999,
});

// Define the props for the ContextMenu component
interface ContextMenuProps {
	pos: { x: number; y: number };
	handleContextMenuSelection: (item: string) => void;
}

export function ContextMenu({
	pos,
	handleContextMenuSelection,
}: ContextMenuProps) {
	// Define the click handler for the menu items
	const handleItemClick = (item: string) => {
		handleContextMenuSelection(item);
	};

	// Render the context menu
	return (
		<ContextMenuContainer
			css={{ "--top": `${pos.y}px`, "--left": `${pos.x}px` }}
		>
			<div
				className="hover:bg-black hover:text-white"
				onClick={() => handleItemClick("cubic-bezier")}
			>
				Cubic-bezier notation
			</div>
			<div
				className="hover:bg-black hover:text-white"
				onClick={() => handleItemClick("clear")}
			>
				Clear keyframe easing
			</div>
		</ContextMenuContainer>
	);
}
